import React, { Fragment, PureComponent } from 'react';

export default class extends PureComponent {
    componentDidMount() {
        const { onExpireCaptcha = () => { }, onVerifyCaptcha = () => { }, size = 'compact' } = this.props;

        window.CAPTCHA_VERIFY = onVerifyCaptcha;
        window.CAPTCHA_EXPIRED = onExpireCaptcha;

        clearInterval(this.loadCaptchaInterval);
        this.loadCaptchaInterval = setInterval(() => {
            if (window.grecaptcha) {
                clearInterval(this.loadCaptchaInterval);
                window.grecaptcha.ready(() => this._renderGreCaptcha(size));
            }
        }, 500);
    }

    componentWillUnmount() {
        clearInterval(this.loadCaptchaInterval);
    }

    _executeGrecaptcha = () => {
        window.grecaptcha.execute();
    }

    _renderGreCaptcha = size => {
        window.grecaptcha.render('captcha', {
            sitekey: process.env.REACT_APP_RECAPTCHA_KEY,
            size,
            expiredCallback: 'CAPTCHA_EXPIRED',
            callback: 'CAPTCHA_VERIFY'
        });
    };

    render() {
        const { buttonCss = '', buttonId = 'captchaButton', disabled = false, label = '', size = 'compact' } = this.props;

        return (
            <Fragment>
                <div id="captcha" />
                {size === 'invisible' ?
                    <button
                        className={buttonCss}
                        disabled={disabled || !window.grecaptcha}
                        id={buttonId}
                        type="button"
                        onClick={this._executeGrecaptcha}
                    >
                        {label}
                    </button>
                    : null}
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/captcha/index.js